import { useEffect, useState } from "react";
import { Palette, Lock, RotateCcw } from "lucide-react";
import { toast } from "sonner";
import api, { formatApiError } from "@/lib/api";
import { Button } from "@/components/ui/button";

const PRESETS = ["#5aa469", "#c0392b", "#d97706", "#0e7490", "#4338ca", "#7c3aed", "#be185d", "#111827"];

export const AccentColorPicker = ({ enabled }) => {
  const [color, setColor] = useState("");
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    api.get("/restaurant").then((r) => { setColor(r.data.accent_color || ""); setLoaded(true); }).catch(() => setLoaded(true));
  }, []);

  const save = async (value) => {
    if (!enabled) { toast.error("Il colore dei pulsanti è disponibile con i piani Pro e Business"); return; }
    try {
      const { data } = await api.put("/restaurant", { accent_color: value });
      setColor(data.accent_color || "");
      toast.success(value ? "Colore dei pulsanti aggiornato" : "Colore predefinito ripristinato");
    } catch (e) {
      toast.error(formatApiError(e.response?.data?.detail));
    }
  };

  if (!loaded) return null;

  return (
    <div className="flex items-center gap-2 flex-wrap" data-testid="accent-color-picker">
      <Palette className="h-4 w-4 text-[#5aa469]" />
      <span className="text-sm text-gray-500">Colore pulsanti</span>
      <div className="flex items-center gap-1.5">
        {PRESETS.map((c) => (
          <button key={c} type="button" onClick={() => save(c)} disabled={!enabled} title={c}
            className={`h-6 w-6 rounded-full border-2 transition-transform hover:scale-110 disabled:opacity-40 disabled:hover:scale-100 ${color === c ? "border-gray-900 scale-110" : "border-white shadow"}`}
            style={{ background: c }} data-testid={`accent-preset-${c.slice(1)}`} />
        ))}
        <label className={`h-6 w-6 rounded-full border-2 border-dashed border-gray-300 overflow-hidden relative ${enabled ? "cursor-pointer" : "opacity-40"}`} title="Colore personalizzato">
          <input type="color" value={color || "#5aa469"} disabled={!enabled} onChange={(e) => save(e.target.value)}
            className="absolute inset-0 h-full w-full opacity-0 cursor-pointer" data-testid="accent-custom-input" />
          <span className="absolute inset-0" style={{ background: "conic-gradient(red, yellow, lime, cyan, blue, magenta, red)" }} />
        </label>
        {color && enabled && (
          <Button type="button" variant="ghost" size="icon" className="h-7 w-7" onClick={() => save("")} title="Ripristina" data-testid="accent-reset">
            <RotateCcw className="h-3.5 w-3.5 text-gray-500" />
          </Button>
        )}
      </div>
      {!enabled && <Lock className="h-4 w-4 text-gray-400" />}
    </div>
  );
};
